import { Layout } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import HeaderBar from 'Layout/HeaderBar';
import FooterBar from 'Layout/FooterBar';
import AnomaliesPage from './Page';
import { useAnomalies } from './useAnomalies';
import type { AnomalyScope } from './types';
import AlertNavigation from '../AlertNavigation';

export function parseAnomalyScope(search: string): { scope?: AnomalyScope; error?: string } {
  const params = new URLSearchParams(search);
  if (!params.has('orgId') && !params.has('sensorId')) return {};
  const orgId = params.get('orgId') || '';
  const sensorId = params.get('sensorId') || '';
  const validId = /^[a-zA-Z0-9_-]{1,160}$/;
  if (!validId.test(orgId) || !validId.test(sensorId)) {
    return { error: 'Linket mangler en gyldig organisation eller sensor. Åbn sensoren fra enhedsoversigten.' };
  }
  return { scope: { orgId, sensorId } };
}

export default function AnomaliesContainer() {
  const { search } = useLocation();
  const { scope, error: scopeError } = parseAnomalyScope(search);
  const { query, events, labels, scan, save, changeLabel, changeScanControl, behaviourService } =
    useAnomalies(scope, !scopeError);
  return (
    <Layout>
      <HeaderBar />
      <Layout.Content className="p-3 md:p-6">
        {!scope && !scopeError && <AlertNavigation active="anomalies" />}
        {scopeError ? (
          <div role="alert" className="anomaly-error">
            {scopeError} <Link to="/sensors">Til enhedsoversigten</Link>
          </div>
        ) : (
          <AnomaliesPage
            key={scope ? `${scope.orgId}:${scope.sensorId}` : 'all'}
            scope={scope}
            events={events}
            labels={labels}
            scan={scan}
            loading={query.isPending}
            error={query.isError ? (query.error as Error).message : null}
            onSave={save}
            onLabelAction={changeLabel}
            onScanControl={scope ? undefined : changeScanControl}
            behaviourService={scope ? undefined : behaviourService}
            onRefresh={() => query.refetch()}
            hasMore={Boolean(query.hasNextPage)}
            loadingMore={query.isFetchingNextPage}
            onLoadMore={() => query.fetchNextPage()}
          />
        )}
      </Layout.Content>
      <FooterBar />
    </Layout>
  );
}
